import { Box, Typography } from "@mui/material";
import React from "react";

function ProfileName({ user, isViewingUser = false }) {
  return (
    <Box flex={2} mt={isViewingUser ? 0 : 2}>
      <Typography
        variant="h5"
        fontWeight="bold"
        gutterBottom
        color="textPrimary"
      >
        Welcome,{" "}
        <Typography variant="span" color="primary">
          {user?.firstName} {user?.lastName}
        </Typography>
      </Typography>

      <Typography variant="subtitle2" color="textSecondary" gutterBottom>
        Email: {user?.email}
      </Typography>
    </Box>
  );
}

export default ProfileName;
